import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { mergeMap, catchError, shareReplay } from 'rxjs/operators';
import { of, from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KeyconfigInitService {
  private config: any;

  constructor(private httpClient: HttpClient) { }
  public getConfig(): Observable<any> {
    return this.httpClient
      .get(this.getConfigFile(), {
        observe: 'response',
      })
      .pipe(
        catchError((error) => {
          console.log(error)
          return of(null)
        }),
        mergeMap((response) => {
          if (response && response.body) {
            this.config = response.body;
            return of(this.config);
          } else {
            return of(null);
          }
        }));
  }
  public load(): Observable<any> {
    return this.httpClient.get(this.getConfigFile()).pipe(
      shareReplay(1)
    );
  }

  private getConfigFile(): string {
    return environment.configFile
  }

  public loadConstants(): Observable<any> {
    return this.httpClient.get(this.getConstantFile()).pipe(
      shareReplay(1)
    );
  }

  private getConstantFile(): string {
    return environment.constantFile
  }

  public loadAppResource(): Observable<any> {
    return this.httpClient.get(this.getAppResourceFile()).pipe(
      shareReplay(1)
    );
  }

  private getAppResourceFile(): string {
    return environment.constantFile
  }
}
